export const ADD_RATERS_INVITES = "ADD_RATERS_INVITES"
export const EDIT_RATERS_INVITES = "EDIT_RATERS_INVITES"
export const LIST_RATERS_INVITES = "LIST_RATERS_INVITES"
export const VIEW_RATERS_INVITES = "VIEW_RATERS_INVITES"
export const DELETE_RATERS_INVITES = "DELETE_RATERS_INVITES"

// Text
export const ADD_RATERS_INVITES_TEXT = "ADD_RATERS_INVITES_TEXT"
export const EDIT_RATERS_INVITES_TEXT = "EDIT_RATERS_INVITES_TEXT"
export const LIST_RATERS_INVITES_TEXT = "LIST_RATERS_INVITES_TEXT"
export const VIEW_RATERS_INVITES_TEXT = "VIEW_RATERS_INVITES_TEXT"
export const DELETE_RATERS_INVITES_TEXT = "DELETE_RATERS_INVITES_TEXT"

export const RATERS_INVITES_SUCCESS = "RATERS_INVITES_SUCCESS"
export const RATERS_INVITES_ERROR = "RATERS_INVITES_ERROR"

